import find from 'lodash/find';
import jQuery from 'jquery';
import EventService from '../common/event/EventService';
import SystemDataEvent from './events/SystemDataEvent';
import UpdateReceivedEvent from './events/UpdateReceivedEvent';
import translate from '../common/localization/translate';

VCOM.anlage = (function () {
  let systemStructure = null;
  const systemData = {};
  let requestActive = false;
  let updateElementsASAP = {};
  let updateElements = () => [];
  let updateSystemDataTimeout = -1;
  let anlagenId;
  let date = null;
  const upToDateness = {
    latest: null,
    oldest: null,
  };

  function loadStructure(anlage, callback, componentsOnly = false) {
    anlagenId = anlage;
    jQuery.ajax({
      url: componentsOnly ? `${VCOM.baseUrl}/default/system-structure/get-components` : `${VCOM.baseUrl}/default/system-structure/get`,
      type: 'POST',
      data: { systemId: anlagenId },
      success(data) {
        systemStructure = getTranslatedStructure(data);
        callback(systemStructure);
      },
      dataType: 'json',
    });
  }

  function subscribeToCurrentSystemData() {
    VCOM.UpdateService.subscribe(VCOM.anlage, 'currentSystemData');
    EventService.addListener(UpdateReceivedEvent.CURRENT_SYSTEM_DATA, {
      callback(event) {
        jQuery.each(event.detail.elements, function () {
          systemData[`${this.type}--${this.id}`] = this;
        });
        VCOM.anlage.setUpToDateness(event.detail.upToDateness);
        EventService.dispatch(`${anlagenId}.${SystemDataEvent.CHANGED}`, { data: [event.detail.elements] });
      },
    });
  }

  function fetchCurrentData(elements) {
    const params = elements;
    jQuery.each(elements, function () {
      updateElements[`${this.type}--${this.id}`] = this;
    });

    jQuery.ajax({
      url: `${VCOM.baseUrl}/monitoring/schema/current-values`,
      type: 'POST',
      data: { updateElements: params, date: VCOM.anlage.getDate() },
      success(data) {
        requestActive = false;
        jQuery.each(data.elements, function () {
          systemData[`${this.type}--${this.id}`] = this;
        });
        // don't change oldest date when updating just a few nodes
        data.upToDateness.oldest = null;
        VCOM.anlage.setUpToDateness(data.upToDateness);
        EventService.dispatch(`${anlagenId}.${SystemDataEvent.CHANGED}`, { data: [data.elements] });
      },
      dataType: 'json',
    });
  }

  function getTranslatedStructure(data) {
    const unassignedDevicesElement = find(data.children, ['id', 'unassignedDevices']);
    if (unassignedDevicesElement) {
      unassignedDevicesElement.label = translate('monitoring.schema.TX_UNASSIGNED_DEVICES');
      const unassignedGaksElement = find(unassignedDevicesElement.children, ['id', 'unassignedGaks']);
      if (unassignedGaksElement) {
        unassignedGaksElement.label = translate('monitoring.schema.TX_UNASSIGNED_COMBINER_BOXES');
      }
    }
    return data;
  }

  return {
    getAnlagenId() {
      return anlagenId;
    },

    getStructure(anlagenIdParam, callback) {
      if (systemStructure !== null) {
        callback(systemStructure);
        return;
      }
      const deferred = jQuery.Deferred();
      loadStructure(anlagenIdParam, deferred.resolve, true);
      deferred.then(function (systemStructureParam) {
        subscribeToCurrentSystemData();
        callback(systemStructureParam);
      });
    },

    updateStructure() {
      const deferred = jQuery.Deferred();
      if (systemStructure !== null && anlagenId !== null) {
        loadStructure(anlagenId, deferred.resolve);
        return deferred;
      }
      return deferred.resolve(false);
    },

    getDate() {
      return date;
    },

    getElementsToUpdate() {
      return updateElements();
    },

    getElement(element) {
      if (typeof element === 'string') {
        const elementParts = element.split('--');
        element = { id: elementParts[2], type: elementParts[1] };
      }
      return systemData[`${element.type}--${element.id}`] || null;
    },

    setStatus(element, status) {
      if (typeof element === 'string') {
        const elementParts = element.split('--');
        element = { id: elementParts[2], type: elementParts[1] };
      }
      if (typeof systemData[`${element.type}--${element.id}`] === 'undefined') {
        systemData[`${element.type}--${element.id}`] = [];
        systemData[`${element.type}--${element.id}`].values = [];
      }
      systemData[`${element.type}--${element.id}`].values.status = status;
      return status;
    },

    getStatus(element) {
      if (typeof element === 'string') {
        const elementParts = element.split('--');
        element = { id: elementParts[2], type: elementParts[1] };
      }
      if (typeof systemData[`${element.type}--${element.id}`] !== 'undefined') {
        return systemData[`${element.type}--${element.id}`].values.status;
      }
      return null;
    },

    updateElement(type, id) {
      if (typeof type === 'undefined' || id.indexOf('unassigned') !== -1) {
        return;
      }
      updateElementsASAP[`${type}--${id}`] = { type, id };
      if (!requestActive) {
        // no request active - fetch values asap
        requestActive = true;
        if (updateSystemDataTimeout > -1) {
          clearTimeout(updateSystemDataTimeout);
        }

        fetchCurrentData(updateElementsASAP);
        // cleanup update-list
        updateElementsASAP = {};
      } else {
        if (updateSystemDataTimeout > -1) {
          clearTimeout(updateSystemDataTimeout);
        }
        const that = this;
        updateSystemDataTimeout = setTimeout(function () {
          that.updateElement();
        }, 1000);
      }
    },

    setDate(sDate) {
      date = sDate;
    },

    setUpToDateness(dates) {
      if (dates.latest !== null) {
        upToDateness.latest = dates.latest;
      }
      if (typeof dates.oldest !== 'undefined') {
        upToDateness.oldest = dates.oldest;
      }
    },

    getUpToDateness() {
      return upToDateness;
    },

    checkElementsToUpdateFunc(func) {
      updateElements = func;
    },
  };
}());
